import {from, Observable} from 'rxjs';
import {filter, mapTo, switchMap} from 'rxjs/operators';

import IErrorsPayload       from '../../Player/Interfaces/IErrorsPayload';
import getIsConnectionOk    from '../../Solutions/Shared/Util/getIsConnectionOk';
import Playback             from '../../State/Stores/Playback/Playback';
import ErrorType            from '../Constants/ErrorType';

const createPlaybackInterruptedConnectionLostStream = (
    playbackUpdate$: Observable<Playback>,
    injectedGetIisConnectionOk: () => Promise<boolean> = getIsConnectionOk
): Observable<IErrorsPayload> =>
    playbackUpdate$
        .pipe(
            filter(playbackUpdate => playbackUpdate.isNetworkInducedBuffering),
            switchMap(() => from(injectedGetIisConnectionOk())),
            filter(isConnectionOk => !isConnectionOk),
            mapTo({
                type: ErrorType.PLAYBACK_INTERRUPTED_CONNECTION_LOST,
                source: null
            })
        );

export default createPlaybackInterruptedConnectionLostStream;
